import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { resetWithEmail, errorDetail } from "@/lib/reader";

export default function ReaderReset() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("The two passwords don't match.");
    setBusy(true);
    try {
      await resetWithEmail(token, password);
      toast.success("Password changed — you're signed in.");
      navigate("/account", { replace: true });
    } catch (err) {
      toast.error(errorDetail(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full bg-[#0B0C10] border border-white/15 px-4 py-3 placeholder:text-white/30 focus:outline-none focus:border-primary-gold";
  return (
    <div className="pt-32 pb-24 px-6 max-w-md mx-auto" data-testid="reader-reset-page">
      <p className="flex items-center gap-2 font-mono-ui text-xs uppercase tracking-[0.25em] text-primary-gold"><KeyRound className="w-4 h-4" /> Your account</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl mt-4">Choose a new password</h1>
      {!token ? (
        <p className="text-soft mt-6" data-testid="reader-reset-missing">
          This link is incomplete. <Link to="/account" className="text-primary-gold">Request a new reset link</Link>.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4 mt-8 border border-white/10 bg-[#121212]/90 p-8">
          <input required type="password" minLength={8} placeholder="New password (8+ characters)" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="reader-reset-password" />
          <input required type="password" minLength={8} placeholder="Repeat new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} data-testid="reader-reset-confirm" />
          <button type="submit" disabled={busy} data-testid="reader-reset-submit" className="w-full flex items-center justify-center gap-2 bg-primary-gold text-[#0B0C10] font-mono-ui text-xs uppercase tracking-[0.2em] py-4 disabled:opacity-50">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Save new password
          </button>
        </form>
      )}
    </div>
  );
}
